import script from "./BaseComponent.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BaseComponent.vue?vue&type=script&lang=js"
export * from "./BaseComponent.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BaseComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/Apps/Engine/BaseComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "642553f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('642553f3', __exports__)) {
    api.reload('642553f3', __exports__)
  }
  
}


export default __exports__